import React from 'react';
import { motion } from 'framer-motion';
export function Brokerage() {
  return <div className="pt-32 pb-24 min-h-screen bg-white" data-id="element-189">
      <div className="max-w-7xl mx-auto px-6" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="max-w-3xl mb-16" data-id="element-191">
          <h1 className="text-5xl font-serif text-charcoal-900 mb-6" data-id="element-192">
            Aircraft Brokerage
          </h1>
          <p className="text-xl text-gray-600" data-id="element-193">
            Expert guidance in aircraft acquisitions and sales, backed by deep
            market intelligence and industry relationships.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-194">
          <div className="bg-brand-50 p-8 rounded-2xl" data-id="element-195">
            <h3 className="text-2xl font-serif text-charcoal-900 mb-4" data-id="element-196">
              Acquisitions
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-197">
              We help you identify, evaluate, and negotiate the purchase of the
              perfect aircraft for your mission profile.
            </p>
            <button className="text-brand-600 font-medium hover:text-brand-700" data-id="element-198">
              View Inventory →
            </button>
          </div>
          <div className="bg-charcoal-900 text-white p-8 rounded-2xl" data-id="element-199">
            <h3 className="text-2xl font-serif mb-4" data-id="element-200">Sales</h3>
            <p className="text-gray-300 mb-6" data-id="element-201">
              Maximize your return with our strategic marketing, global network,
              and expert negotiation skills.
            </p>
            <button className="text-brand-400 font-medium hover:text-brand-300" data-id="element-202">
              List Your Aircraft →
            </button>
          </div>
        </div>
      </div>
    </div>;
}